var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      _vm.show &&
      (_vm.ext.toLocaleUpperCase() == '.MP4' || _vm.ext.toLocaleUpperCase() == '.FLV')
    )?_c('div',[_c('div',{staticClass:"video-preview",on:{"click":_vm.handleClose}}),_c('video',{staticClass:"video",attrs:{"controls":"controls","autoplay":"autoplay"}},[_c('source',{attrs:{"src":_vm.urls[0],"type":"video/mp4"}})])]):_vm._e(),(
      _vm.show &&
      (_vm.ext.toLocaleUpperCase() == '.JPG' ||
        _vm.ext.toLocaleUpperCase() == '.PNG' ||
        _vm.ext.toLocaleUpperCase() == '.DOC' ||
        _vm.ext.toLocaleUpperCase() == '.DOCX' ||
        _vm.ext.toLocaleUpperCase() == '.PDF')
    )?_c('div',[_c('el-image-viewer',{attrs:{"on-close":_vm.handleClose,"url-list":_vm.urls}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }